import React from "react";
import '../App.css';

const NotFound = () => {
  return (
    <div className="fullscreen-container">
      <h1>PAGE NOT FOUND</h1>
    </div>
  );
};

export default NotFound;